import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useWorkspaceStore = create(
  persist(
    (set) => ({
      activeWorkspaceId: null,
      setActiveWorkspaceId: (activeWorkspaceId) => set({ activeWorkspaceId }),
      clearActiveWorkspace: () => set({ activeWorkspaceId: null }),
    }),
    {
      name: 'do-sense-workspace',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ activeWorkspaceId: s.activeWorkspaceId }),
    },
  ),
)

export function getActiveWorkspaceId() {
  return useWorkspaceStore.getState().activeWorkspaceId
}

export function clearActiveWorkspace() {
  useWorkspaceStore.getState().clearActiveWorkspace()
}
